/**
 * Scroll Reveal Animation
 * 
 * Implements scroll-triggered fade-in animations using IntersectionObserver.
 * Elements with the `.js-reveal` class will fade and slide into view when
 * they enter the viewport. Respects prefers-reduced-motion preferences.
 */

function initScrollReveal() {
  // Check if user prefers reduced motion
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  
  // If reduced motion is preferred, show all elements immediately
  if (prefersReducedMotion) {
    const revealElements = document.querySelectorAll('.js-reveal');
    revealElements.forEach((el) => {
      el.classList.add('reveal--visible');
    });
    return;
  }

  // Check if IntersectionObserver is supported
  if (!('IntersectionObserver' in window)) {
    // Fallback: show all elements immediately if IntersectionObserver is not supported
    const revealElements = document.querySelectorAll('.js-reveal');
    revealElements.forEach((el) => {
      el.classList.add('reveal--visible');
    });
    return;
  }

  // Create IntersectionObserver with reasonable threshold
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal--visible');
          // Unobserve after animation to avoid unnecessary work
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.05, // Trigger when 5% of element is visible (lower for large elements)
      rootMargin: '0px 0px 0px 0px', // Trigger as soon as element enters viewport
    }
  );

  // Observe all elements with .js-reveal class
  const revealElements = document.querySelectorAll('.js-reveal');
  revealElements.forEach((el) => {
    observer.observe(el);
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollReveal);
} else {
  // DOM is already ready
  initScrollReveal();
}

export default initScrollReveal;

